import bankAccount from './bank-account'

export default {
  name: 'Account',
  path: 'account',
  meta: {
    label: 'financialAccount',
    auth: 'account'
  },
  component: {
    name: 'Account',
    render(c) {
      return c('router-view')
    }
  },
  children: [bankAccount]
}
